/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_Tax_RefusedInputs */

const vi_einvoice_stuck_tax_refused = /** @type {(inputs: Einvoice_Stuck_Tax_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ quan thuế từ chối hóa đơn này. Cần lập hóa đơn điều chỉnh/thay thế trên MISA.`)
};

/**

* @param {Einvoice_Stuck_Tax_RefusedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_tax_refused = /** @type {((inputs?: Einvoice_Stuck_Tax_RefusedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Tax_RefusedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_tax_refused(inputs)
});